import type { RegisterApplicationConfig, SingleSpaCustomEventDetail } from 'single-spa'
import type { CustomProps } from '../../common'
import { assertIsSingleSpaCustomEvent, SINGLE_SPA_BEFORE_MOUNT_EVENT } from '../../common/single-spa-events'
import { getExtensionsManager } from '../../extensions/extensions-manager'
import { getTopbarAPI } from '../../services/topbar'
import { canShowTopBar } from '../bootstrap-helpers'
import { findAppByName } from '../helpers/registered-app'
import type { ShellHook } from './models'

const isRegisterApplicationConfig = (
  item: RegisterApplicationConfig<CustomProps> | undefined,
): item is RegisterApplicationConfig<CustomProps> => !!item
const findRegisteredApplicationsByNames = (
  mountedApps: readonly string[],
): readonly RegisterApplicationConfig<CustomProps>[] =>
  mountedApps
    .map((mountedApp: string) => findAppByName(mountedApp, getExtensionsManager().getRegisteredApplications()))
    .filter(isRegisterApplicationConfig)

const applicationHasHideTopbarConfig = (
  registerApplicationsConfigs: readonly RegisterApplicationConfig<CustomProps>[],
): boolean =>
  registerApplicationsConfigs.some(registerApplication => {
    const { customProps } = registerApplication
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return !!(customProps as any)?.shellConfig?.hideTopbar
  })

const updateTopbarVisibility = (event: CustomEvent<SingleSpaCustomEventDetail>) => {
  assertIsSingleSpaCustomEvent(event)
  const mountedApps = event.detail?.appsByNewStatus?.MOUNTED as string[]
  if (mountedApps.length === 0) {
    return
  }
  const registeredApplications = findRegisteredApplicationsByNames(mountedApps)
  const hideTopbar = !canShowTopBar() || applicationHasHideTopbarConfig(registeredApplications)
  if (hideTopbar) {
    getTopbarAPI().hide()
  } else {
    getTopbarAPI().show()
  }
}

export const initializeTopBarVisibility: ShellHook = async () => {
  globalThis.addEventListener(SINGLE_SPA_BEFORE_MOUNT_EVENT, updateTopbarVisibility)
}
